import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePathname } from 'next/navigation';
import Slider from '@/app/components/Slider';
import { cn } from '@/utils/cn';
import fetchFrequentlyBoughtTogether from '@/redux/thunk/frequently-bought-together';
import DynamicSectionTitle from '../Typography/DynamicSectionTitle';

function PdpFrequentlyBoughtTogetherProductCarousel({ section }) {
  const pathname = usePathname();
  const dispatch = useDispatch();
  const { items, isLoading } = useSelector(
    (state) => state.frequentlyBoughtTogether,
  );
  const { lang: selectLang } = useSelector((state) => state.globalSettings);
  const { currentParentProductDetail } = useSelector(
    (state) => state.productDetail,
  );

  const currentProductSlug = currentParentProductDetail?.product?.slug;

  useEffect(() => {
    dispatch(
      fetchFrequentlyBoughtTogether({
        slug: currentProductSlug,
      }),
    );
  }, []);

  if (Array.isArray(items) && items?.length === 0) return null;

  return (
    <section>
      <div className="container mx-auto">
        <DynamicSectionTitle
          text={section?.title[selectLang]}
          className={cn({
            'text-center': pathname === '/',
          })}
        />
      </div>
      <Slider type="frequently-bought" items={items} isLoading={isLoading} />
    </section>
  );
}

export default PdpFrequentlyBoughtTogetherProductCarousel;
